module.exports = __webpack_public_path__ + "img/5.5fb8b6b.png";